// No parser needed yet. Kept this file for future needs and code consistency
export default response => response;
